import Accomplishments from "./Accomplishments";

export default Accomplishments;
